"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElstrUserActionsTypes = {
    ELSTR_USER_DID_LOGIN: "ELSTR_USER_DID_LOGIN",
    ELSTR_USER_DID_LOGOUT: "ELSTR_USER_DID_LOGOUT",
};
//# sourceMappingURL=ActionTypes.js.map